import { useEffect, useCallback } from 'react';

const Swal = window.Swal;

function Alert({ config, setConfirm }) {
  const {
    typeIcon,
    title,
    description,
    confirmButtonText,
    cancelButtonText,
    cancelButtonClass,
    showCancelButton,
  } = config;

  const handleAlert = useCallback(() => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: cancelButtonClass || 'btn btn-danger',
      },
      buttonsStyling: false,
      allowOutsideClick: () => !showCancelButton,
    });

    if (!showCancelButton) {
      Swal.fire(title, description, typeIcon);
      setConfirm(false);
      return;
    }

    swalWithBootstrapButtons
      .fire({
        title: title,
        text: description,
        icon: typeIcon,
        showCancelButton: showCancelButton,
        confirmButtonText: confirmButtonText || 'Confirm',
        cancelButtonText: cancelButtonText || 'Cancel',
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          setConfirm(true);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          setConfirm(false);
        }
      });
  }, [
    typeIcon,
    title,
    description,
    confirmButtonText,
    cancelButtonText,
    cancelButtonClass,
    showCancelButton,
    setConfirm,
  ]);

  useEffect(() => {
    handleAlert();
  }, [handleAlert]);

  return null;
}

export default Alert;
